// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import ClearFormController from "./clear_form_controller"
application.register("clear-form", ClearFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FacebookShareController from "./facebook_share_controller"
application.register("facebook-share", FacebookShareController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import PhoneClickTrackerController from "./phone_click_tracker_controller"
application.register("phone-click-tracker", PhoneClickTrackerController)

import PhoneRevealerController from "./phone_revealer_controller"
application.register("phone-revealer", PhoneRevealerController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)
